import { Config, Configs } from './types';

export function createConfig(configs: Configs, envName: keyof Configs): Config {
  return Object.assign({}, configs.DEFAULT, configs[envName]);
}
